<template>
  <div class="crowdApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="search">
      <div class="left" @click="$router.push('citys')">
        <span>当前位置</span>
        <font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>
      </div>
    </div>
    <div style="height:55px"></div>
    <ul>
      <li v-for="(item,i) in setCrowd" @click="toPush(item.id,'crowd-detail')">
        <div class="title">
          <img :src="baseUrl+item.images" >
          <div class="conTitle">
            <span>{{item.title}}</span>
            <font>有效期：{{item.expired}}年</font>
            <div class="price">总价<i><b>¥</b>{{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="none" v-if="setCrowd.length <= 0">
      <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
      <a @click="$router.push('citys')">切换地区</a>
    </div>
    <div style="height:15px"></div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        userData:[],
        setCrowd:[],
        baseUrl:'',
        code:'',
        cityData:[],
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/crowd');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        if(localStorage.getItem('cCode') == null){
          this.getQquey()
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            this.getQquey();
          }else{
            this.cityData = cCode;
            this.getscenic();
          }
        }
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        window.location.href="http://user.4008005216.com/main/"+url+'?id='+index
        /*this.$router.push({
          path:url,
          query:{
            id:index
          }
        })*/
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            that.fullscreenLoading = true;
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getscenic();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getscenic:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/crowd/getCrowdList',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setCrowd = data.data
            that.fullscreenLoading = false
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .crowdApp{
    display:block;
    background:#ececec;
    width:100%
  }
  .crowdApp .search{
    position:fixed;
    width:100%;
    left:0;
    background:#ececec;
    height:55px;
    top:0;
    z-index:99
  }


  .crowdApp .search .left{
    float:left;
    height:55px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .crowdApp .search .left span{
    width:40px;
    float:left;
    font-size:15px;
    color:#000;
    line-height:18px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .crowdApp .search .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#000;
    border-radius:10px;
    right:0
  }
  .crowdApp .search .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:15px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .crowdApp ul{
    display:block;
    margin:0 auto;
    width:94%
  }
  .crowdApp ul li{
    display:block;
    width:100%;
    margin-bottom:15px;
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .crowdApp ul li .title{
    position:relative;
    width:100%;
  }
  .crowdApp ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .crowdApp ul li .title img{
    float:left;
    width:23%;
    border-radius:6px;
    margin-left:3%
  }
  .crowdApp ul li .title .conTitle{
    float:left;
    width:70%;
    margin-left:2%;
  }
  .crowdApp ul li .title .conTitle span{
    display:block;
    color:#000;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:15px;
    font-weight: 600;
  }
  .crowdApp ul li .title .conTitle font{
    color:#666;
    font-size:12px;
    padding-top:6px;
    display:block;
  }

  .crowdApp ul li .title .conTitle .price{
    font-size: 12px;
    font-family: PingFang SC;
    color: #666;
    padding-top:6px
  }
  .crowdApp ul li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .crowdApp ul li .title .conTitle .price b{
    font-size:12px;
    padding-right:2px
  }
  .crowdApp .none{
    width:80%;
    margin:0 auto;
    padding-top:20%
  }
  .crowdApp .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .crowdApp .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .crowdApp .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }
</style>